import axios from "axios";
import store from "../../store/index";
import riskPopup from "../../components/RAC_Insight/riskpopup.vue";
import criticalSignal   from "../../components/CriticalSignalPopup/CriticalSignalPopup.vue";
import dataSignalPopup from "../../components/DataSignalPopup/DataSignalPopup.vue";

export default {
  name: "SiteRiskDashboard",
  components: {
    riskPopup,
    criticalSignal,
    dataSignalPopup,
  },
  data() {  
    return {
        studyId: store.getters.getStudyIs,
        baseurl: process.env.VUE_APP_Service_URL,
        idToken: store.getters.getIdToken,
        head:{},
        siteId:"",
        dataSignal: [],
        rirskData: [],
        totalSignals:0,
        flaggedSignals:0,
        flaggedItems:[],
        flaggedPercentage:0,
        totalRisks:0,
        highRisks:0,
        mediumRisks:0,
        highRiskItems:[],
        mediumRiskItems:[],
        highRiskPercentage:0,
        mediumRiskPercentage:0,
        groupedRisks:{ },
        showRiskPop: false,
        riskPopupData: [],
        signalPopupData: [],
        showDataSignalPopup: false,
        signalHeading:"Data Signals",
    };
  },
  async mounted() {
    window.addEventListener("studyIdChanged", (event) => {
            this.studyId= store.getters.getStudyIs,
            this.listSites();
            this.getdatasignal();
            this.getRiskScoreInfo();
            this.claculateSignals();
            this.calculateRiskSummary();
            this.groupRisksByCategory();
        });

    this.head = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    },
    await this.listSites();
    await this.getdatasignal();
    await this.getRiskScoreInfo();
    await this.claculateSignals();
    await this.calculateRiskSummary();
    await this.groupRisksByCategory();
  },    
    methods: {
        async listSites() {
            try {
                const response = await axios.get(
                    `${this.baseurl}/management/site/getallsitesbyuser?studyId=${this.studyId}&sortProperty=siteCode&IsDes=false&getAll=false`,this.head
                );
                this.siteId = response.data[0].siteID || "";
            } catch (error) {
                console.error("Error fetching sites:", error);
            }
        },
        async getdatasignal() {
            await axios.get(`${this.baseurl}/forms/rbqm/getdatasignal?StudyId=${this.studyId}&SiteId=${this.siteId}`, this.head
            ).then((response) => {
                this.dataSignal = response.data || [];
                console.log(response.data);
            }   
            ).catch((error) => {
                console.log(error); 
            });
        },
        async getRiskScoreInfo(){
            await axios.get(`${this.baseurl}/forms/rbqm/getscoreinfos?StudyId=${this.studyId}&DataScope=Site&DataScopeId=${this.siteId}&RecordType='Risk'`, this.head
            ).then((response) => {
                this.rirskData = response.data || [];
                console.log("risk data:", this.rirskData.entities);
            }).catch((error) => {
                console.log(error);
            });
        },
        async claculateSignals(){
            this.totalSignals = this.dataSignal.length;
            this.flaggedItems = this.dataSignal.filter(x => x.flagged === true);
            this.flaggedSignals = this.flaggedItems.length;
             this.flaggedPercentage = this.totalSignals > 0
                    ? ((this.flaggedSignals / this.totalSignals) * 100).toFixed(2)
                    : 0;
        },
        async calculateRiskSummary() {
            const risks = this.rirskData.entities;
            this.totalRisks = this.rirskData.totalCount;

            // ✅ Normalize level (handle Moderate = Medium)
            const getLevel = (x) => {
                if (!x.riskLevelLabel) return '';
                const level = x.riskLevelLabel.toLowerCase();

                if (level === 'moderate') return 'medium';
                return level;
            };

            // ✅ Grouping
            this.highRiskItems = risks.filter(x => getLevel(x) === 'high');
            this.mediumRiskItems = risks.filter(x => getLevel(x) === 'medium');

            // ✅ Counts
            this.highRisks = this.highRiskItems.length;
            this.mediumRisks = this.mediumRiskItems.length;

            // ✅ Percentages
            this.highRiskPercentage = this.totalRisks > 0
                ? ((this.highRisks / this.totalRisks) * 100).toFixed(2)
                : 0;

            this.mediumRiskPercentage = this.totalRisks > 0
                ? ((this.mediumRisks / this.totalRisks) * 100).toFixed(2)
                : 0;
        },
        async groupRisksByCategory() {
            const risks = this.rirskData.entities;

            // ✅ Validate that risks data exists
            if (!risks || !Array.isArray(risks)) {
                this.groupedRisks = {};
                return;
            }

            const normalizeLevel = (level) => {
                if (!level) return '';
                level = level.toLowerCase();

                if (level === 'moderate') return 'medium'; 
                return level;
            };

            const grouped = {};

            risks.forEach(item => {
            const category = item.category || 'Others';
            const level = normalizeLevel(item.riskLevelLabel);

            if (!grouped[category]) {
                grouped[category] = {
                high: [],
                medium: []
                };
            }

            // push into respective group
            if (level === 'high') {
                grouped[category].high.push(item);
            } else if (level === 'medium') {
                grouped[category].medium.push(item);
            }
            });

            // ✅ Sort each group (High → highest score first)
            Object.keys(grouped).forEach(category => {
            grouped[category].high.sort((a, b) => b.score - a.score);
            grouped[category].medium.sort((a, b) => b.score - a.score);
            });

            // ✅ Sort categories by number of HIGH risks (descending) - prioritize high-risk categories first
            const sortedCategories = Object.keys(grouped).sort((a, b) => {
                return grouped[b].high.length - grouped[a].high.length;
            });

            // ✅ Rebuild grouped object in priority order
            const prioritizedGrouped = {};
            sortedCategories.forEach(category => {
                prioritizedGrouped[category] = grouped[category];
            });

            this.groupedRisks = prioritizedGrouped;

            console.log("Grouped Category Risks (sorted by HIGH priority):", prioritizedGrouped);
        },
        openRiskPoup(riskData){
            this.riskPopupData = this.mapRiskItemForPopup(riskData);
            this.showRiskPop = true;
        },
        closeRiskkpopup(){
            this.showRiskPop = false;
        },
        mapRiskItemForPopup(riskData) {
            return riskData.map(item => ({
                id: item.id,
                siteCode: item.siteName,              
                riskName: item.riskName,
                riskLevelColor: item.riskLevelColor,
                score: item.score,
                riskLevelLabel: item.riskLevelLabel,
                probability: item.probabilityPoint,   
                impact: item.impactPoint,             
                detectability: item.detectabilityPoint 
            }))
        },
        totalRiskClicked(){
            this.openRiskPoup(this.rirskData.entities);
        },
        highRiskClicked(){
            this.openRiskPoup(this.highRiskItems);
        },
        mediumRiskClicked(){
            this.openRiskPoup(this.mediumRiskItems);
        },
        HighCategoryRiskClicked(data){
            this.openRiskPoup(data);
        },
        MediumCategoryRiskClicked(data){
            this.openRiskPoup(data);
        },
        openDataSignalPopup(signalData,popupHeading ){
            this.signalPopupData = signalData;
            this.signalHeading = popupHeading;
            this.showDataSignalPopup = true;
        },
        closeDataSignalPopup(){
            this.showDataSignalPopup = false;
        },
        totalSignalsClicked(){
            this.openDataSignalPopup(this.dataSignal,"Data Signals");
        },
        flaggedSignalsClicked(){
            this.openDataSignalPopup(this.flaggedItems,"Flagged Data Signals");
        },
    }
};   
